@let etlBannerDisplaySettings = settings();

<div class="banner-container" *ngIf="etlBannerDisplaySettings != null && etlBannerDisplaySettings?.etlStatus !== 0 && etlBannerDisplaySettings.showDataHealth">
  <div class="d-flex align-items-center alert" id="etlBanner"
       *ngIf="etlBannerDisplaySettings?.etlStatus !== 0 && etlBannerDisplaySettings.showDataHealth &&
       etlBannerDisplaySettings.spendETLEnabled && !etlBannerDisplaySettings.bannerDismissed"
       [ngClass]="{'border-alert': etlBannerDisplaySettings.etlStatus === 1, 'border-warning': etlBannerDisplaySettings.etlStatus === 2}">
    <div class="icon d-flex justify-content-center"
         [ngClass]="{'icon-alert' : etlBannerDisplaySettings.etlStatus === 1, 'icon-warning' : etlBannerDisplaySettings.etlStatus === 2}">
      <i class="fas fa-exclamation-triangle" *ngIf="etlBannerDisplaySettings.etlStatus === 2"></i>
      <i class="fas fa-exclamation-square" *ngIf="etlBannerDisplaySettings.etlStatus === 1"></i>
    </div>
    <div class="content ml-5 d-flex">
    <span class="bold align-self-center" style="text-decoration: underline; cursor: pointer;"
          [innerHTML]="etlBannerDisplaySettings.title" (click)="this.dataHealthService.openHealthModal()">
      - </span><span class="ml-5" [innerHtml]="etlBannerDisplaySettings.message"></span>
    </div>
  <div class="dismiss d-flex justify-content-center" style="cursor: pointer;">
    <i class="fa fa-times" style="margin-left: 5px;" (click)="dismiss();"
       [attr.data-testid]="'etl-status-dismiss'"></i>
  </div>
</div>
